import type { AdminOrderPage, AdminOrderQuery } from "@shared/admin";
import type { OrderEvent } from "@shared/contracts";

function queryString(query: AdminOrderQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== "") params.set(key, String(value));
  return params.toString();
}

export async function fetchRemoteOperatorOrders(query: AdminOrderQuery = { offset: 0, limit: 100, sortBy: "createdAt", sortDirection: "desc" }, fetcher: typeof fetch = fetch): Promise<AdminOrderPage | null> {
  const response = await fetcher.call(globalThis, `/api/operator/orders?${queryString(query)}`, { credentials: "same-origin" });
  if (response.status === 401 || response.status === 403 || response.status === 503) return null;
  if (!response.ok) throw new Error(`Operator order history request failed (${response.status})`);
  return (await response.json()) as AdminOrderPage;
}

export type RemoteOperatorOrderDetail = {
  order: AdminOrderPage["orders"][number];
  events: OrderEvent[];
};

export async function fetchRemoteOperatorOrderDetail(orderId: string, fetcher: typeof fetch = fetch): Promise<RemoteOperatorOrderDetail | null> {
  if (!orderId) throw new Error("orderId is required");
  const response = await fetcher.call(globalThis, `/api/operator/orders/${encodeURIComponent(orderId)}`, { credentials: "same-origin" });
  if (response.status === 401 || response.status === 403 || response.status === 404 || response.status === 503) return null;
  if (!response.ok) throw new Error(`Operator order detail request failed (${response.status})`);
  return (await response.json()) as RemoteOperatorOrderDetail;
}
